import React from "react"
import { sortStagesDataBySequenceNo } from "./ProductionSchedule.utils"

const formatStationsData = data =>
   data?.map(s => s?.department?.departmentName).join(", ") || "-"

const Stages = ({ stagesData }) => {
   return (
      <div className="stages">
         <div className="stages-heading">Stages</div>
         {sortStagesDataBySequenceNo(stagesData).map((stage, index) => (
            <div key={index} className="stages-stage ">
               <div className="stages-stage-stagename tooltip-container">
                  <p className="tooltip-target trim-text-2 pointer px-3">
                     {stage?.name || "-"}
                  </p>
                  <span className="custom-tooltip">{stage?.name}</span>
               </div>
               <div className="stages-stage-station">
                  <div className="tooltip-container">
                     <p className="tooltip-target trim-text-2 pointer px-3">
                        {formatStationsData(stage?.stations)}
                     </p>
                     <span className="custom-tooltip">
                        {formatStationsData(stage?.stations)}
                     </span>
                  </div>
               </div>
            </div>
         ))}
      </div>
   )
}

export default Stages
